import React from 'react';
import PropTypes from 'prop-types';

const statusColors = {
  all: '#8e24aa', // purple
  success: '#2e7d32', // green
  Waiting: '#1976d2', // blue
  pending: '#ffa000', // orange
  reject: '#f44336', // red
  inform: '#fa8c16', // ส้ม — ขอข้อมูลเพิ่ม (แยกจาก reject ที่เป็นความผิด)
};

const statusLabels = {
  all: 'ทั้งหมด',
  success: 'Success',
  Waiting: 'Waiting',
  pending: 'Pending',
  reject: 'Reject',
  inform: 'Inform',
};

const DashboardBox = ({ status, count, items }) => (
  <div
    style={{
      background: statusColors[status],
      color: 'white',
      borderRadius: 10,
      padding: 12,
      minWidth: 180,
      margin: 4,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
      flex: 1,
    }}
  >
    <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 4 }}>
      {statusLabels[status]}
    </div>
    <div style={{ fontSize: 32, fontWeight: 300, marginBottom: 8, alignSelf: 'center' }}>
      {count}
    </div>
    <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: 4 }}>
      {items.map((item, idx) => (
        <div
          key={item.label}
          style={{
            background: 'rgba(255,255,255,0.9)',
            color: '#222',
            borderRadius: 6,
            flex: '1 1 45%',
            minWidth: 60,
            padding: '6px 0',
            textAlign: 'center',
            marginBottom: 4,
            fontWeight: 500,
            fontSize: 13,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            gap: 6,
          }}
        >
          <span>{item.label}</span>
          {((status === 'pending' || status === 'Waiting') && item.value !== "-") ? (
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 26,
                height: 26,
                borderRadius: '50%',
                background: 'red',
                color: 'white',
                fontWeight: 700,
                fontSize: 15,
                marginLeft: 8,
                marginRight: 0,
                boxShadow: '0 1px 4px rgba(0,0,0,0.10)',
                lineHeight: 1,
                textAlign: 'center',
              }}
            >
              {item.value}
            </span>
          ) : (
            <span
              style={{
                fontSize: 15,
                fontWeight: 500,
                color: (status === 'Waiting') ? 'red' : '#222',
                marginLeft: 8,
              }}
            >
              {item.value}
            </span>
          )}
        </div>
      ))}
    </div>
  </div>
);

DashboardBox.propTypes = {
  status: PropTypes.oneOf(['all', 'success', 'Waiting', 'pending', 'reject']).isRequired,
  count: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
};

export default DashboardBox;
